import Layout from "@/components/feature/Layout";
import PageHero from "@/components/base/PageHero";
import SectionHeader from "@/components/base/SectionHeader";
import CTAPanel from "@/components/base/CTAPanel";

const serviceAreas = [
  {
    title: "Power Apps",
    description: "Power Apps development and support for enterprise business applications, creating custom applications that connect to data sources and workflows.",
    icon: "ri-window-line",
  },
  {
    title: "Power Automate",
    description: "Power Automate (Flow) workflow automation and process integration support for enterprise business processes and data flows.",
    icon: "ri-window-line",
  },
  {
    title: "Power BI",
    description: "Power BI support for data visualization, reporting, and business intelligence dashboards within enterprise environments.",
    icon: "ri-window-line",
  },
  {
    title: "SharePoint",
    description: "SharePoint site creation, workflow configuration, and collaboration platform support for enterprise content management and team collaboration.",
    icon: "ri-window-line",
  },
  {
    title: "Workflow Solutions",
    description: "Workflow design and implementation using Nintex Forms and Workflows, Power Automate, and SharePoint native workflow capabilities.",
    icon: "ri-window-line",
  },
  {
    title: "Application Integration",
    description: "Integration support connecting Microsoft platforms with enterprise data sources, applications, and business systems.",
    icon: "ri-window-line",
  },
  {
    title: "Requirements & Design Support",
    description: "Requirements gathering and design oversight support for Microsoft platform implementations and business application projects.",
    icon: "ri-window-line",
  },
  {
    title: "Testing & Training",
    description: "Testing support and user enablement training for Microsoft Power Platform and SharePoint enterprise deployments.",
    icon: "ri-window-line",
  },
];

export default function MicrosoftSolutions() {
  return (
    <Layout>
      <PageHero
        title="Microsoft Power Platform & SharePoint"
        subtitle="Enterprise Solutions"
        description="Power Apps, Power Automate, Power BI, SharePoint, and workflow solutions for enterprise business applications."
        size="md"
      />

      <section className="section-padding bg-white">
        <div className="container-page">
          <SectionHeader
            title="Service Areas"
            description="Microsoft platform and workflow services supporting enterprise infrastructure, application, and database practice areas."
          />
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
            {serviceAreas.map((area) => (
              <div key={area.title} className="card-base p-6">
                <div className="w-10 h-10 rounded-lg bg-primary-50 flex items-center justify-center mb-4">
                  <i className={`${area.icon} text-primary-600`}></i>
                </div>
                <h3 className="text-lg font-bold text-foreground-900 mb-2">
                  {area.title}
                </h3>
                <p className="text-sm text-foreground-600 leading-relaxed">
                  {area.description}
                </p>
              </div>
            ))}
          </div>

          <div className="mt-14 bg-background-100 rounded-lg p-6 border border-background-200/80">
            <h3 className="text-lg font-bold text-foreground-900 mb-4">
              Capability Overview
            </h3>
            <p className="text-sm text-foreground-600 leading-relaxed">
              Power Platform and SharePoint expertise covers Power Apps, Power Automate/Flow, Power BI, SharePoint sites and workflows, integration, requirements, design oversight, testing, and training. These solutions are delivered across enterprise and large-scale technology engagements as a core part of Mitaja's Microsoft platform practice.
            </p>
          </div>
        </div>
      </section>

      <CTAPanel
        title="Interested in Microsoft Platform Support?"
        description="Mitaja delivers Microsoft Power Platform and SharePoint solutions for enterprise and large-scale technology programs."
        primaryAction={{ label: "Contact Us", href: "/contact" }}
        secondaryAction={{ label: "View All Capabilities", href: "/capabilities" }}
        variant="dark"
      />
    </Layout>
  );
}